// import {getStore, setStore, removeStore} from '../../utils/storage.js'

const state = {}

const mutations = {}

const actions = {

}

const getters = {}

export default {
  state,
  actions,
  mutations,
  getters,
  namespaced: true
}



// WEBPACK FOOTER //
// ./src/store/modules/permission.js